import {
  queryCompanyGatewayFiles,
  postCompanyGatewayFile,
} from '@/services/company';

export default {
  namespace: 'Devices_gatewayFiles',

  state: {
    data: {},
  },

  effects: {
    *fetch({ payload }, { call, put }) {
      const { status, data } = yield call(queryCompanyGatewayFiles, payload);

      if (status === 200) {
        yield put({
          type: 'save',
          payload: {
            list: data.data,
            pagination: {
              total: data.meta.total,
              pageSize: data.meta.per_page,
              current: data.meta.current_page,
            },
          },
        });
      }
    },

    *postFile({ payload, callback }, { call }) {
      yield call(postCompanyGatewayFile, payload);
      callback();
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        data: payload,
      };
    },
  },
};
